import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";

import MxFormTextThousandField, {
  MxFormTextThousandFieldProps
} from "@rf-l2/form/text-fields/MxFormTextThousandField";
interface MxFormL3TextThousandFieldProps extends MxFormTextThousandFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3TextThousandField = (props: MxFormL3TextThousandFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormTextThousandField label={props.label} {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3TextThousandField;
